// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__D1vV9","overflowing":"ReadFullNote_overflowing__1AT3Q"};